import styled from 'styled-components';

export const ActionsWrap = styled.div`
  justify-content: space-between;
  display: flex;
  button,
  a {
    display: inline-block;
  }
`;

export const ButtonsWrapper = styled.span`
  visibility: hidden;
`;

export const LoadingSpacer = styled.div`
  @keyframes Pulsate {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0.75;
    }
    to {
      opacity: 1;
    }
  }
  height: 2.4rem;
  width: 60%;
  background: ${({ theme }) => theme.colors.functional.gray3};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  animation: Pulsate 0.5s ease-in infinite;
`;

export const TableWrapper = styled.div`
  background: ${({ theme }) => theme.colors.functional.white};
  box-shadow: ${({ theme }) => theme.boxShadow.blue};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  padding: 0 0 1rem 0;
  & > section {
    overflow-x: auto;
    min-height: 240px;
  }
  margin-bottom: 100px;
  td:first-child,
  th:first-child {
    padding-left: 3.2rem;
  }
  td:last-child,
  th:last-child {
    padding-right: 3.2rem;
  }
  table {
    width: ${({ theme }) => theme.container.lg};
    text-align: left;
    border-collapse: collapse;
    font-size: 1.4rem;
    @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
      font-size: 1.3rem;
    }
  }
  thead {
    height: 70px;
    box-shadow: inset 0 -2px 0 0 ${({ theme }) => theme.colors.functional.gray3};
    @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
      height: 60px;
    }
  }
  tbody {
    width: 100%;
    overflow: hidden;
    tr {
      height: 100px;
      @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
        height: 80px;
      }
      td {
        box-shadow: inset 0 -2px 0 0 ${({ theme }) => theme.colors.functional.gray3};
      }
    }
    tr:last-child {
      td {
        box-shadow: none;
      }
    }
  }
`;
